import seoConfig from './seoConfig';
import { buildCanonicalUrl } from './siteConfig';
import { buildWebApplicationSchema } from './structuredData';

const getPageSeo = (key) => {
  const config = seoConfig[key];
  if (!config) return null;

  const canonicalUrl = config.path ? buildCanonicalUrl(config.path) : undefined;
  const structuredData = config.path
    ? buildWebApplicationSchema({
        title: config.title,
        description: config.description,
        url: canonicalUrl,
      })
    : undefined;

  return {
    ...config,
    canonicalUrl,
    structuredData,
  };
};

export default getPageSeo;
